import * as types from './actionTypes';
import { fetchKPI } from '../api/urlHelper';

export function receiveKpiData(json) {
  const data = json.kpis || {};
  return {type: types.RECEIVE_KPI_DATA, data}
}

export function fetchKpiData({ startDate, endDate, dealType, partner }) {
  return dispatch => {
    return fetchKPI({ startDate, endDate, dealType, partner })
      .then(kpiData => {
        dispatch(receiveKpiData(kpiData));
      })
      .catch(err => {
        console.error(err);
        dispatch(receiveKpiData({}));
      });
  };
}
